import React from "react";

const EmployeeRoles = ({ row }) => {
  return (
    <div>
      {row.roles?.map((role, index) => (
        <div key={`${role.id || index}`} className="mb-4">
          {role.roleTitle}
        </div>
      ))}
    </div>
  );
};

export default EmployeeRoles;
